import { useEffect, useState } from 'react';
import { Route, Routes } from 'react-router-dom';
import { VesselDetails } from 'VesselDetails/VesselDetails';
import { PortDetails, PortsPage, FleetPage, MapPage, VesselsPage, NotificationsPage, AtonsPage, WelcomePage } from 'app/pages';
import { Layout, AreasList, RoutePlanner, SafetyList } from 'app/components';

import { ProtectedRoute } from 'app/helpers';

import { useAppDispatch, useAppSelector } from 'app/store/store';
import { useLazyGetUserDataQuery } from 'app/api/user';
import { setUiConfig, setUser, setUserProfile } from 'app/utils/userSlice';
import { useAlertHook } from 'app/hooks';
import { useLazyGetSystemConfigurationQuery, useLazyGetUserProfileQuery } from 'app/api/facade';
import { AnalyticsFilterPanel } from 'app/components/AnalyticsFilterPanel';
import { WorldFleetPage } from '../WorldFleetPage';

export const Main = () => {
  const { addAlert } = useAlertHook();
  const dispatch = useAppDispatch();
  const uiConfig = useAppSelector((state) => state.userSlice.uiConfig);

  const auth = useAppSelector((state) => state.userSlice.auth);
  const user = useAppSelector((state) => state.userSlice.user);

  const [getUser, { data: getUserResult, ...getUserRequest }] = useLazyGetUserDataQuery({});
  const [getConfiguration, { data: uiConfiguration }] = useLazyGetSystemConfigurationQuery();
  const [getProfile, { data: profileData }] = useLazyGetUserProfileQuery();
  const localCenter = localStorage.getItem('center');
  const [initCenter, setInitCenter] = useState<number[]>((localCenter && JSON.parse(localCenter)) || [0, 0]);

  useEffect(() => {
    if (auth?.value.loggedIn) {
      getUser({})
        .unwrap()
        .catch((error: Error) => addAlert(error));
      getConfiguration()
        .unwrap()
        .catch((error: Error) => addAlert(error));
      getProfile()
        .unwrap()
        .catch((error: Error) => addAlert(error));
    }

    if (getUserRequest.isSuccess && getUserResult) {
      dispatch(setUser(getUserResult));
    }
  }, [auth, getUserRequest.isSuccess, getUserResult, addAlert]);

  useEffect(() => {
    if (profileData?.result) {
      dispatch(setUserProfile(profileData.result));
    }
  }, [profileData]);

  useEffect(() => {
    if (uiConfiguration?.result) {
      dispatch(setUiConfig(uiConfiguration?.result));
    }
  }, [uiConfiguration]);
console.log(process.env.NODE_ENV)
  return (
    <Routes>
      {process.env.NODE_ENV === 'development' && <Route path="/welcome" element={<WelcomePage />} />}
      <Route element={<Layout user={user} uiconfig={uiConfig} withSearch setInitCenter={setInitCenter} />}>
        <Route
          path="/"
          element={
            <ProtectedRoute>
              <MapPage initCenter={initCenter} />
            </ProtectedRoute>
          }
        />

        <Route
          path="/mapview"
          element={
            <ProtectedRoute>
              <MapPage initCenter={initCenter} />
            </ProtectedRoute>
          }
        />
      </Route>

      <Route element={<Layout user={user} uiconfig={uiConfig} setInitCenter={setInitCenter} />}>
        <Route
          path="/vessels"
          element={
            <ProtectedRoute>
              <VesselsPage user={user} />
            </ProtectedRoute>
          }
        />
        <Route
          path="/atons"
          element={
            <ProtectedRoute>
              <AtonsPage user={user} />
            </ProtectedRoute>
          }
        />
        <Route
          path="/vessels/:mmsi"
          element={
            <ProtectedRoute>
              <VesselDetails setInitCenter={setInitCenter} />
            </ProtectedRoute>
          }
        />

        <Route
          path="/ports"
          element={
            <ProtectedRoute>
              <PortsPage user={user} />
            </ProtectedRoute>
          }
        />
        <Route
          path="/ports/:portKey"
          element={
            <ProtectedRoute>
              <PortDetails setInitCenter={setInitCenter} />
            </ProtectedRoute>
          }
        />
        <Route
          path="/fleet"
          element={
            <ProtectedRoute>
              <FleetPage user={user} />
            </ProtectedRoute>
          }
        />

        <Route
          path="/history"
          element={
            <ProtectedRoute>
              <MapPage mode={'history'} initCenter={initCenter} />
            </ProtectedRoute>
          }
        />
        {
          <Route
            path="/analytics"
            element={
              <ProtectedRoute>
                <MapPage mode={'analytics'} initCenter={initCenter} sideComponent={<AnalyticsFilterPanel />} />
              </ProtectedRoute>
            }
          />
        }

        {
          <Route
            path="/world_fleet"
            element={
              <ProtectedRoute>
                <WorldFleetPage />
              </ProtectedRoute>
            }
          />
        }

        <Route
          path="/areas"
          element={
            <ProtectedRoute>
              <MapPage mode={'areas'} sideComponent={<AreasList />} initCenter={initCenter} />
            </ProtectedRoute>
          }
        />
        <Route
          path="/safety"
          element={
            <ProtectedRoute>
              <MapPage mode={'safety'} sideComponent={<SafetyList setInitCenter={setInitCenter} />} initCenter={initCenter} />
            </ProtectedRoute>
          }
        />
        <Route
          path="/routes"
          element={
            <ProtectedRoute>
              <MapPage mode={'routes'} sideComponent={<RoutePlanner />} initCenter={initCenter} />
            </ProtectedRoute>
          }
        />
        <Route
          path="/notifications"
          element={
            <ProtectedRoute>
              <NotificationsPage />
            </ProtectedRoute>
          }
        />
        {
          <Route
            path="/playback"
            element={
              <ProtectedRoute>
                <MapPage mode={'playback'} initCenter={initCenter} />
              </ProtectedRoute>
            }
          />
        }
      </Route>
    </Routes>
  );
};
